import { childrenLogisticsNetworkPageBreadcrumbs } from '../../config';
import { useDriversFilter, useDriversPagination } from './hooks';
import { SearchBar, DriversTable } from './components';
import { useNavigate } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { NavigateLinks } from '@/components';
import { DriversFilter } from './models';

export const Drivers = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenLogisticsNetworkPageBreadcrumbs(navigate),
    [navigate]
  );

  const { filter, setFilter, initialFilter } = useDriversFilter();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useDriversPagination();

  const handleDriverSearch = useCallback(
    (filters: DriversFilter) => {
      const next: DriversFilter = {
        search: filters.search || '',
        email: filters.email || undefined,
        phone: filters.phone || undefined,
        status: filters.status || undefined,
        currentOperatorId: filters.currentOperatorId || undefined,
      };

      setFilter((prev) => {
        const unchanged =
          (prev.search || '') === next.search &&
          (prev.email || '') === (next.email || '') &&
          (prev.phone || '') === (next.phone || '') &&
          (prev.status || '') === (next.status || '') &&
          (prev.currentOperatorId || '') === (next.currentOperatorId || '');
        if (unchanged) return prev;
        handlePageChange(1);
        return next;
      });
    },
    [handlePageChange]
  );

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks actualPage='Conductores' breadcrumbs={breadcrumbs} />
      <SearchBar
        onSearch={handleDriverSearch}
        initialFilter={initialFilter}
        currentFilter={filter}
      />
      <DriversTable
        driversFilter={filter}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </section>
  );
};

export default Drivers;
